$(function () {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const $container = $(entry.target);
        const $num = $container.find('h2');

        const originalText = $num.text().trim();

        // Extract the first number found in the string
        const match = originalText.match(/(\d+)/);
        if (!match) return; // no number found

        const targetCount = parseInt(match[0], 10);

        // Split the text into: before number, number, after number
        const before = originalText.slice(0, match.index);
        const after = originalText.slice(match.index + match[0].length);

        $({ Counter: 0 }).animate({ Counter: targetCount }, {
          duration: 3000,
          easing: 'swing',
          step: function () {
            const value = Math.ceil(this.Counter);
            // Rebuild the text with the animated number
            $num.text(before + value + after);
          }
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });

  $('.animated-stat').each(function () {
    observer.observe(this);
  });
});